<template>
  <div class="container accueil">
    <Introduction class="bloc_intro" />

    <div class="card carte_principale">
      <div class="card-body">
        <h1 class="titre_proposition_accueil">Je réinscris mon enfant :</h1>
        <div class="rangee_cas">
          <router-link class="div_btn_cas" :to="{ name: 'reinscription-formulaire-cas-1' }">
            <button class="cas btn">
              <span class="titre"
                >MATERNELLE OU PRIMAIRE<br />
                <span class="description">(de la petite section au CM2)</span>
              </span>
            </button>
          </router-link>

          <router-link class="div_btn_cas" :to="{ name: 'reinscription-scolaire' }">
            <button class="cas btn">
              <span class="titre"
                >COLLÈGE OU<br />LYCÉE<br />
                <span class="description">(de la 6ème à la Terminale)</span>
              </span>
            </button>
          </router-link>
        </div>

        <h1 class="titre_proposition_accueil">OU<br /><br />Mon enfant entre en :</h1>
        <div class="rangee_cas">
          <router-link class="div_btn_cas" :to="{ name: 'formulaire-cas-1' }">
            <button class="cas btn">
              <span class="titre"
                >MATERNELLE OU PRIMAIRE<br />
                <span class="description">(de la petite section au CM2)</span>
              </span>
            </button>
          </router-link>

          <router-link class="div_btn_cas" :to="{ name: 'formulaire-cas-2' }">
            <button class="cas btn">
              <span class="titre" id="cc2t"
                >COLLÈGE OU LYCÉE DE LA COMMUNAUTÉ DE COMMUNES TERRES TOULOISES<br />
                <span class="description">(de la 6ème à la Terminale)</span>
              </span>
            </button>
          </router-link>

          <router-link class="div_btn_cas" :to="{ name: 'formulaire-cas-3' }">
            <button class="cas btn">
              <span class="titre" id="hors_cc2t"
                >COLLÈGE OU LYCÉE HORS COMMUNAUTÉ DE COMMUNES TERRES TOULOISES<br />
                <span class="description">(de la 6ème à la Terminale)</span>
              </span>
            </button>
          </router-link>
        </div>
      </div>
    </div>

    <div class="div_mention">
      <span class="mention"
        >Vous n'habitez pas sur le territoire de la communauté de communes terres touloises ? Votre demande doit
        être adressée à la Région Grand Est :
        <a id="lien_mention" href="https://www.fluo.eu/54">www.fluo.eu/54</a>
      </span>
    </div>
  </div>
</template>

<script setup>
import Introduction from '../components/Introduction.vue'
</script>

<style scoped lang="scss">
@import '../sass/app';

.accueil {
  .bloc_intro {
    margin-bottom: 3rem;
  }

  .carte_principale {
    padding: 1rem 0 2rem 0;
    box-shadow: 0 0 20px 0 lightgray;
    border-radius: 10px;

    .titre_proposition_accueil {
      margin-top: 2rem;
      color: $firstcolor !important;
      margin-bottom: 2rem;
    }

    .rangee_cas {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 1rem;

      .div_btn_cas {
        flex: 0 0 auto;
        margin: 0;

        .cas {
          max-height: 176px;
          margin-top: 1rem;
          padding: 1.5rem;
          width: 291px;
          color: $firstcolor;
          background-color: white;
          border: 1px solid $firstcolor;
          border-radius: 5px;
          text-align: center;

          @include media-breakpoint-down(xs) {
            width: 278px;
            max-height: 200px;
          }

          .titre {
            font-family: $titlefont !important;
            font-size: 20px !important;
          }

          #hors_cc2t,
          #cc2t {
            font-size: 17.2px !important;
          }

          .description {
            font-size: 14px !important;
          }


        }

        .cas:hover {
          text-decoration: none;
          background-color: $firstcolor !important;
          color: white;
        }
      }
    }
  }

  .div_mention {
    margin-top: 1rem;
    display: flex;

    .mention {
      margin: auto;
      width: 100%;
      color: grey;
      font-size: 14px !important;
      text-align: center;

      #lien_mention {
        color: grey;
      }
    }
  }
}
</style>